import { PravoNaGo } from './pravo-na-go';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, NotificationService } from 'yt-ng-framework';
import { FormGroup, Validators } from '@angular/forms';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as var_config from '../../var_config';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-pravo-na-go-update',
  templateUrl: './pravo-na-go-update.component.html'
})
export class PravoNaGoUpdateComponent
  extends BaseUpdateComponent<PravoNaGo> implements OnInit {
  varConfig=var_config;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService

  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('OsobaID', Validators.required, 'required', 'PRAVONAGO.OSOBAID.VALIDATION.REQUIRED');
    this.addValidatorToFc('Godina', Validators.required, 'required', 'PRAVONAGO.GODINA.VALIDATION.REQUIRED');

    // this.IDProcessed
    //     .subscribe(() => {
    //         if(this.Item.ID == -1){
    //             let dateNow = new Date();
    //             let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
    //             this.baseFormGroup.patchValue({ Datum: date });
    //             this.baseFormGroup.get('Sifra').updateValueAndValidity();
    //         }
    //     })

  }

  editMode: boolean = false;
  item: any;
}
